<template>
  <div class="content-block">
    <TaskForm
      :taskId="taskId"
      @done="onDone"
      @back="onBack"
    >
    </TaskForm>
  </div>
</template>

<script>
import TaskForm from 'CORE/components/task/form'
import isString from 'lodash/isString'
import get from 'lodash/get'

export default {
    name: 'TaskEditView',
    components: {
        TaskForm,
    },
    computed: {
        taskId() {
            const id = get(this.$route.params, 'id')
            console.assert(isString(id), `ID must be a string`) // TODO check if id is valid uuid or not
            return id
        },
    },
    methods: {
        onDone() {
            const backProjectId = get(this.$route.query, 'backProjectId', false)
            if (backProjectId) {
                this.$router.push({ name: 'projectsDetail', params: { id: backProjectId } })
            } else {
                this.$router.push({ name: 'tasksList', params: { status: '$all' } })
            }
        },
        onBack() {
            window.history.back(1)
        },
    },
}
</script>
